import { inject, Injectable } from '@angular/core';
import { BillingService as CmsApiBillingService } from '../../../core/cms-api/services/billing.service';
import { Observable } from 'rxjs';
import {
  ConnectedAccountStatusResponseResult,
  PayoutStatisticsResponseResult,
  Result,
  SearchTransfersRequest,
  SubscriptionsAndPlansStatsResponseResult,
  TransferFilterParametersResponseResult,
  TransferListItemResponsePagedResponseResult,
} from '../../../core/cms-api/models';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  private apiBillingService = inject(CmsApiBillingService);

  getConnectedAccountStatus(
    operatorId: string,
  ): Observable<ConnectedAccountStatusResponseResult> {
    return this.apiBillingService.billingConnectedAccountStatusOperatorIdGet({
      operatorId: operatorId,
    });
  }

  getPayoutStats(
    operatorId: string,
    dateFrom?: string | null,
    dateTo?: string | null,
  ): Observable<PayoutStatisticsResponseResult> {
    return this.apiBillingService.billingPayoutStatisticsOperatorIdPost({
      operatorId: operatorId,
      body: {
        from: dateFrom ?? undefined,
        to: dateTo ?? undefined,
      },
    });
  }

  getSubscriptionAndPlanStats(
    operatorId: string,
  ): Observable<SubscriptionsAndPlansStatsResponseResult> {
    return this.apiBillingService.billingSubscriptionsAndPlansStatsOperatorIdGet(
      {
        operatorId: operatorId,
      },
    );
  }

  getTransferFilters(
    operatorId: string,
  ): Observable<TransferFilterParametersResponseResult> {
    return this.apiBillingService.billingGetTransferFilterParametersOperatorIdPost(
      {
        operatorId: operatorId,
      },
    );
  }

  searchTransfers(
    request: SearchTransfersRequest,
  ): Observable<TransferListItemResponsePagedResponseResult> {
    return this.apiBillingService.billingSearchTransfersPost({
      body: request,
    });
  }

  recallTransfer(transferId: string): Observable<Result> {
    return this.apiBillingService.billingRecallTransferPost({
      body: {
        transferId: transferId,
      },
    });
  }
}
